import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export default function useCommon() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const store = (selector) => useSelector(selector);
  const themeColor = localStorage.getItem("sidenav_color") || "primary";
  const formatDateUS = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  return {
    DISPATCH: dispatch,
    NAVIGATE: navigate,
    LOCATION: location,
    SEARCH_PARAMS: searchParams,
    SET_SEARCH_PARAMS: setSearchParams,
    STORE: store,
    THEME_COLOR: themeColor,
    FORMAT_DATE: formatDateUS,
  };
}
